import { IonActionSheet, IonButton, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonRow, isPlatform, IonSpinner } from '@ionic/react';
import { checkmarkCircle, checkmarkCircleOutline, close, search } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import NoFilterResults from '../../components/noFilterResults';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { capitalize, deepCopy, forwardTo, getDefaultRoute, getDistanceUnit, goBack, isDefined, isEmptyObject, isTimeAvaibleInMenu, isTimeInRange, parseAllergenData, weekdays } from '../../lib/utils';
import location from '../../assets/images/map-pin-filled.svg';
import { getIkentooMenusForLocation, getRestaurants, setScrollTop } from '../../store/actions';
import './index.css';
import OrderList from './orderList';
import TileOrderList from './tileOrderList';
import moment from 'moment';
import { checkSnoozedTimes, formatDataForTime, isStoreOpened } from '../clickAndCollect';
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/acute.svg';
import { ReactComponent as TableIcon } from '../../assets/images/picnic-table.svg';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import navConfig from '../../navConfig';
const { shouldAddPrepTime } = Basket;
const getMenuDisplayType = () => {
	const { menuDisplayType, flags } = getConfig();
	return flags?.hasMenuTileButtons && menuDisplayType === 1 ? 2 : menuDisplayType;
};

class OrderPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCategory: 0,
			ikentooMenu: null,
			originalMenu: null,
			menuRefs: null,
			categoriesPositionTop: [],
			selectedMenu: [],
			searchItemsValue: '',
			searchOpened: false,
			searchModalOpen: false,
			selectedDietary: [],
			selectedAllergens: [],
			draftDietary: [],
			draftAllergens: [],
			selectRestaurantsModalOpen: false,
			scrollToCategoryKey: null,
			hideCategoryBar: false,
		};
		this.selectCategoryOnScroll = this.selectCategoryOnScroll.bind(this);
	}

	setIkentooMenu = (menu) => {
		this.setState(
			{
				ikentooMenu: menu || (isEmptyObject(this.props.ikentooMenu) && isEmptyObject(Basket.getRestaurant())) ? this.props.defaultMenu : this.props.ikentooMenu,
				originalMenu: menu || (isEmptyObject(this.props.ikentooMenu) && isEmptyObject(Basket.getRestaurant())) ? this.props.defaultMenu : this.props.ikentooMenu,
			},
			() => {
				let menuRefs = this.menuRefs(this.state.ikentooMenu);
				this.setState({ menuRefs });
				if (this.hasActiveMenuFilters()) {
					this.filterMenuItems(this.state.searchItemsValue);
				}
				setTimeout(() => {
					if (document.querySelector('.store-selected')) {
						document.querySelector('.store-selected').scrollIntoView({ inline: 'center' })
					}
				}, 100);
			},
		);
	};
	componentDidMount() {
		this.props.dispatch(getRestaurants({ skipLoading: true }));
		const { scrollTop } = this.props;
		const menuFilters = this.props.location.state?.menuFilters;
		if (!getConfig().flags.removeFiltersFromMenu && menuFilters && (menuFilters.searchItemsValue || menuFilters.selectedDietary.length > 0 || menuFilters.selectedAllergens.length > 0)) {
			this.setState({ ...menuFilters, searchOpened: true });
		}
		this.setIkentooMenu();
		const returningFromItemDetails = getConfig().flags.hasContinuosScrollMenu && this.props.location.state;
		this.setState({
			selectedMenuType: returningFromItemDetails ? 1 : getMenuDisplayType(),
			...(returningFromItemDetails ? { hideCategoryBar: true } : {}),
		});
		if (this.props.location.state) {
			this.setState({ selectedMenu: this.props.location.state.selectedMenu });
		}
		setTimeout(() => {
			const item = document.querySelector('.order-list-items');
			if (item && !isEmptyObject(this.props.location.state)) {
				item.scrollTop = scrollTop;
				if (!isPlatform('ios')) {
					item.scrollBy({ top: 1 });
				}
			}
		}, 100);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.scrollToCategoryKey && prevState.scrollToCategoryKey !== this.state.scrollToCategoryKey) {
			setTimeout(() => {
				const key = this.state.scrollToCategoryKey;
				if (this.state.menuRefs?.[key]?.current) {
					this.state.menuRefs[key].current.scrollIntoView();
				}
				this.setState({ scrollToCategoryKey: null });
			}, 50);
		}
	}

	handleScrollToCategory = (category, index) => {
		this.setState({ selectedMenuType: 1, scrollToCategoryKey: `${category.name}_${index}`, hideCategoryBar: true });
	};

	shouldComponentUpdate(nextProps) {
		const prevMenuName = (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu) ? nextProps.defaultMenu : nextProps.ikentooMenu || {}).menuName;
		const currentMenuName = (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu) ? this.props.defaultMenu : this.props.ikentooMenu || {}).menuName;
		if (prevMenuName !== currentMenuName || nextProps.restaurantsUpdated !== this.props.restaurantsUpdated) {
			this.setIkentooMenu();


		}
		return true;
	}
	menuRefs = (menuRefs) => {
		return menuRefs && menuRefs.menuEntryGroups
			? menuRefs.menuEntryGroups.reduce((acc, value, index) => {
				let name = `${value.name}_${index}`;
				acc[name] = React.createRef();
				return acc;
			}, {})
			: {};
	};

	scrollTo = (name) => this.state.menuRefs[name].current.scrollIntoView();
	selectCategoryOnScroll = (e) => {
		const scrollTop = Math.abs(e.target.scrollTop);
		e.preventDefault();
		const positionTop = scrollTop + (document.querySelector('.order-categories')?.clientHeight ?? 0);
		const { menuRefs } = this.state;
		const positions = Object.keys(menuRefs).map((key) => {
			return menuRefs[key].current.offsetTop;
		});
		let selectCategory = 0;
		positions.forEach((item, i) => {
			if (item <= positionTop) {
				selectCategory = i;
			}
		});
		if (document) {
			const catDiv = document.querySelector('.order-categories-inner');
			if (catDiv && catDiv.childNodes && catDiv.childNodes[selectCategory]) {
				catDiv.childNodes[selectCategory].scrollIntoView({
					inline: 'start',
				});
			}
		}
		this.props.dispatch(setScrollTop(scrollTop));
		this.setState({ selectedCategory: selectCategory, scrollTop: scrollTop });
	};

	backHandler = () => {
		if (this.state.hideCategoryBar) {
			this.setState({ selectedMenuType: getMenuDisplayType(), hideCategoryBar: false });
			if (document.querySelector('.segment-holder')) {
				document.querySelector('.segment-holder').scroll({ top: 0 });
			}
			return;
		}
		let menuDisplayType = this.state.selectedMenuType;
		const selectedMenus = this.state.selectedMenu || [];
		if (menuDisplayType !== 1 && selectedMenus.length > 0) {
			const items = this.state.selectedMenu;
			items.pop();
			this.setState({ selectedMenu: items });
			if (document.querySelector('.segment-holder')) {
				document.querySelector('.segment-holder').scroll({ top: 0 })
			}
		} else {
			const path = Basket.getDeliveryOption()?.route ?? getDefaultRoute(this.props.navConfig).path;
			forwardTo(path, { saveOrderData: true });
		}
	};
	hideBack = () => {
		if (this.state.hideCategoryBar) return false;
		let menuDisplayType = getMenuDisplayType();
		const selectedMenus = this.state.selectedMenu || [];
		if (menuDisplayType !== 1 && selectedMenus.length > 0) {
			return false;
		} else {
			return true;
		}
	};

	selectMenu = (index) => {
		const selectedItem = index;
		const currentCategories = this.state.selectedMenu ? [...this.state.selectedMenu] : [];
		currentCategories.push(selectedItem);
		this.setState({ selectedMenu: currentCategories });
	};

	parseCategories = (data) => {
		const { menuDisplayType, ikentooMenu } = data;
		const selectedMenu = data.selectedMenu || [];

		let categories;
		if (menuDisplayType !== 1) {
			categories = !isEmptyObject(ikentooMenu) ? ikentooMenu : [];
			if (selectedMenu.length > 0) {
				categories = categories.menuEntryGroups[selectedMenu[0]];
				for (let i = 1; i < selectedMenu.length; i++) {
					categories = categories.menuEntry[selectedMenu[i]];
				}
			}
		} else {
			categories = !isEmptyObject(ikentooMenu) ? ikentooMenu.menuEntryGroups : [];
		}
		return categories;
	};
	filterMenu(menu) {
		if (menu && menu.menuEntryGroups) {
			menu.menuEntryGroups = this.filterIkentooMenuItems(menu.menuEntryGroups);
			return menu;
		}
		return menu;
	}
	matchesMenuFilters(item, dietary = this.state.selectedDietary, allergens = this.state.selectedAllergens) {
		const { searchItemsValue } = this.state;
		const selectedDietary = dietary;
		const selectedAllergens = allergens;
		if (!Basket.getProductName(item, this.props.profile).toLowerCase().includes(`${searchItemsValue.toLowerCase()}`)) {
			return false;
		}
		const itemDietary = (item.itemRichData?.dietaryFlags || []).map((flag) => flag.standard_name);
		if (!selectedDietary.every((flag) => itemDietary.includes(flag))) {
			return false;
		}
		const itemAllergens = item.itemRichData?.allergenCodes || [];
		return !selectedAllergens.some((code) => itemAllergens.includes(code));
	}
	filterIkentooMenuItems(items) {
		let filteredItems = [];
		items.forEach((item) => {
			if (!item.menuEntry) {
				// break recursion when arrive to the product
				if (this.matchesMenuFilters(item)) {
					filteredItems.push(item);
					return [item];
				} else {
					return [];
				}
			} else {
				const len = (item.menuEntry || []).length;
				if (len > 0) {
					const newFilteredItems = this.filterIkentooMenuItems(item.menuEntry);
					if (newFilteredItems.length > 0) {
						item.menuEntry = newFilteredItems;
						filteredItems.push(item);
					}
				}
			}
		});

		return filteredItems;
	}
	getMenuFilters = () => ({ searchItemsValue: this.state.searchItemsValue, selectedDietary: this.state.selectedDietary, selectedAllergens: this.state.selectedAllergens });
	hasActiveMenuFilters = () => this.state.searchItemsValue !== '' || this.state.selectedDietary.length > 0 || this.state.selectedAllergens.length > 0;
	filterMenuItems = (value) => {
		this.setState({ searchItemsValue: value }, () => {
			if (getMenuDisplayType() !== 1) {
				if (this.state.selectedMenuType !== 1 && this.hasActiveMenuFilters()) {
					this.setState({ selectedMenuType: 1 }, () => {
						const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
						const filtered = this.filterMenu(menu);
						this.setState({ ikentooMenu: filtered }, () => {
							let menuRefs = this.menuRefs(this.state.ikentooMenu);
							this.setState({ menuRefs });
						});
					});
				} else if (this.state.selectedMenuType === 1 && !this.hasActiveMenuFilters()) {
					this.setState({ selectedMenuType: getMenuDisplayType() }, () => {
						const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
						const filtered = this.filterMenu(menu);
						this.setState({ ikentooMenu: filtered }, () => {
							let menuRefs = this.menuRefs(this.state.ikentooMenu);
							this.setState({ menuRefs });
						});
					});
				} else {
					const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
					const filtered = this.filterMenu(menu);
					this.setState({ ikentooMenu: filtered }, () => {
						let menuRefs = this.menuRefs(this.state.ikentooMenu);
						this.setState({ menuRefs });
					});
				}
			} else {
				const menu = JSON.parse(JSON.stringify(this.state.originalMenu));
				const filtered = this.filterMenu(menu);
				this.setState({ ikentooMenu: filtered }, () => {
					let menuRefs = this.menuRefs(this.state.ikentooMenu);
					this.setState({ menuRefs });
				});
			}
		});
	};

	formatDayName = (__, name) => {
		if (name.includes('Today')) {
			name = 'Today'.toLowerCase();
		} else if (name.includes('Tomorrow')) {
			name = 'Tomorrow'.toLowerCase();
		} else {
			name = Basket.getOrderDate();
		}
		return name;
	};
	drawContentHeader = (__, deliveryOption, orderType, deliveryAddress) => {
		const hasLocationAndTime = Basket.getRestaurant() && (
			(Basket.getOrderTime() && Basket.getOrderTime() !== 'Invalid date') ||
			Basket.getTableNumber() ||
			(deliveryAddress && !isEmptyObject(deliveryAddress)) ||
			(!isEmptyObject(deliveryOption) && (deliveryOption.id === 'pick-up-point' || deliveryOption.id === 'browse-menu'))
		);
		if (!hasLocationAndTime) {
			return null;
		}
		let dateName = this.formatDayName(
			__,
			moment(Basket.getOrderDate(), 'dddd Do MMMM').calendar(null, {
				sameDay: '[Today]',
				nextDay: '[Tomorrow]',
			}),
		);
		const selectedRestaurant = Basket.getRestaurant();
		if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-point') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'charter-delivery' && !isEmptyObject(deliveryAddress)) {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>

					{this.props.driverBookingPending ? (
						<>
							<div></div>
							<div>
								<div>
									<div>
										<StrongText>{__('Booking delivery...')}</StrongText>
									</div>
									<Spacer size={0} />
									<SmallText>{__('Allocating an available driver for your order...')}</SmallText>
								</div>
								<div>
									<IonSpinner name={'circular'} style={{ height: '30px', width: '30px' }} />
								</div>
							</div>
						</>
					) : (
						<>
							{this.props.driverBookingMessage ? (
								<>
									<div></div>
									<div>
										<div style={{ display: 'flex', marginRight: 'var(--spacer-2)' }}>
											<IonIcon style={{ height: '25px', width: '25px' }} color="success" icon={checkmarkCircle} />
										</div>
										<div>

											<div>
												<StrongText>{__('Booking delivery...')}</StrongText>
											</div>
											<SmallText>{__('Driver successfully booked')}</SmallText>
										</div>

									</div>
								</>
							) : (
								<>
									<div>
										<LocationIcon className='fill-label' />
										<StrongText>{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}
										</StrongText>
									</div>
									<div>
										<TimeIcon className='fill-label' />
										<NormalText>
											{dateName}  {Basket.is_asap ? 'ASAP' : `${__('at')} ${Basket.getOrderTime()}`}
										</NormalText>
									</div>

								</>
							)}
						</>
					)}
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'table') {
			return (
				<>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />{' '}
							<StrongText>{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<TableIcon className='fill-label' />{' '}

							<NormalText>{__('Table number')}</NormalText>
							<NormalText className="bold">{Basket.getTableNumber()}</NormalText>
						</div>
					</div>
				</>

			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-collection') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />{' '}
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
					<div>
						<TimeIcon className='fill-label' />{' '}
						<NormalText>{__('Collection time')}</NormalText>
						<NormalText >
							{Basket.additional_data?.named_time_slots_data ? (
								<>
									{dateName} {'at'} {Basket.additional_data?.named_time_slots_data}
								</>
							) : (
								<>
									{dateName} {'at'} {Basket.getOrderTime('h:mm a')}
								</>
							)}
						</NormalText>
					</div>

				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-at-counter') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />{' '}
						<StrongText>{Basket.getRestauranName()}</StrongText>
					</div>
					<div>
						<TimeIcon className='fill-label' />{' '}
						<NormalText>{__('Collection time')}</NormalText>
						<NormalText >{__('ASAP')}</NormalText>
					</div>
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'browse-menu' && selectedRestaurant) {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />{' '}

						<StrongText >{selectedRestaurant.name} &nbsp;</StrongText>
						{selectedRestaurant.browse_menu_json_time_selector > 1 ? (
							<div onClick={() => forwardTo(`/browse-menu?bl_id=${selectedRestaurant.business_location_id}`)}>
								<NormalText className="bold link underlined">{`${__('View other menus')}`}</NormalText>
							</div>
						) : null}
					</div>
					<div>
						<NormalText className="block">{__(selectedRestaurant.address)}</NormalText>
					</div>
					{selectedRestaurant?.distance && (
						<div className="distance-wrapper">
							<IonIcon className="location-icon" icon={location}></IonIcon>
							<NormalText className="block bold-description click-collect-small-description">
								{`${parseFloat(selectedRestaurant.distance.toFixed(2)) == 1 ? selectedRestaurant.distance.toFixed(0) : selectedRestaurant.distance.toFixed(2)} ${__(getDistanceUnit(parseFloat(selectedRestaurant.distance.toFixed(2)) == 1))}`}
							</NormalText>
						</div>
					)}
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-delivery') {
			return (
				<div className="box-content order-header-content">
					<div>
						<LocationIcon className='fill-label' />
						<StrongText className="bold">{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}</StrongText>
					</div>
					<div>
						<TimeIcon className='fill-label' />
						<NormalText>{dateName} {__('at')} {Basket.getOrderTime('h:mm a')}</NormalText>
					</div>

				</div>
			);
		} else {
			return (
				<>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />
							<StrongText>{Basket.getRestauranName()}</StrongText>
							<EditIcon className='fill-label' style={{ margin: 0 }} onClick={() => forwardTo('/click-and-collect', { saveBasket: true })} />
						</div>
						<div>
							<TimeIcon className='fill-label' />{' '}

							<NormalText>{__('Collection time')}</NormalText>
							<NormalText> {Basket.is_asap ? 'ASAP' : `${Basket.getOrderTime('h:mm a')}`}</NormalText>
						</div>
					</div>
				</>

			);
		}
	};
	onSearchHandler = () => {
		if (getConfig().flags.removeFiltersFromMenu) {
			this.setState({ searchOpened: !this.state.searchOpened }, () => {
				if (!this.state.searchOpened) {
					this.setState({ selectedMenu: [] }, () => this.filterMenuItems(''));
				} else {
					setTimeout(() => {
						document.querySelector('#products_search')?.setFocus();
					}, 0);
				}
			});
			return;
		}
		this.setState({ searchModalOpen: true, draftDietary: this.state.selectedDietary, draftAllergens: this.state.selectedAllergens }, () => {
			setTimeout(() => {
				document.querySelector('#products_search')?.setFocus();
			}, 300);
		});
	};
	closeSearchModal = () => {
		this.setState({ searchModalOpen: false });
	};
	getAllergenLabel = (code) => {
		const [label] = parseAllergenData(this.props.profile, { itemRichData: { allergenCodes: [code] } }, this.props.allergens);
		return capitalize(`${label ?? code}`.toLowerCase().replace(/_/g, ' '));
	};
	getDietaryLabel = (flag) => capitalize(flag.toLowerCase().replace(/_/g, ' '));
	toggleMenuFilter = (key, value) => {
		const selected = this.state[key].includes(value) ? this.state[key].filter((el) => el !== value) : [...this.state[key], value];
		this.setState({ [key]: selected });
	};
	clearMenuFilters = () => {
		this.setState({ draftDietary: [], draftAllergens: [], selectedDietary: [], selectedAllergens: [] }, () => this.onSearchInputHandler(''));
	};
	applyMenuFilters = () => {
		this.setState({ selectedDietary: this.state.draftDietary, selectedAllergens: this.state.draftAllergens, searchModalOpen: false }, () => {
			const active = this.hasActiveMenuFilters();
			this.setState({ searchOpened: active, ...(active ? {} : { selectedMenu: [] }) }, () => this.filterMenuItems(this.state.searchItemsValue));
		});
	};
	selectMultiVenueRestaurant = (restaurant) => {
		this.setState({ selectedMenu: [] }, () => {
			Basket.setRestaurant(restaurant);
			if (Basket.order_type == 'collection') {
				const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime,
							json_time_selector: restaurant ? restaurant.json_time_selector : [],
						}),
					);
				});
			} else if (Basket.order_type == 'table') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.table_json_time_selector : [],
						}),
					);
				});
			} else if (Basket.order_type == 'pick-up-at-counter') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(
							restaurant.business_location_id,
							{
								pickTime: 'asap',
								json_time_selector: restaurant ? restaurant.pick_up_at_counter_json_time_selector : [],
							},
							false,
						),
					);
				});
			} else if (Basket.order_type == 'browse-menu') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(
							restaurant.business_location_id,
							{
								pickTime: 'asap',
								json_time_selector: restaurant ? restaurant.browse_menu_json_time_selector : [],
							},
							restaurant.browse_menu_json_time_selector.length === 1 ? false : true,
						),
					);
				});
			} else if (Basket.order_type == 'charter-delivery') {
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.charter_delivery_times_json : [],
						}),
					);
				});
			} else if (Basket.order_type == 'scheduled-delivery') {
				const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime,
							json_time_selector: [
								{
									menuId: restaurant?.active_menus.scheduled_delivery?.menu_id,
									availability: Object.keys(restaurant?.active_menus.scheduled_delivery?.slots).map((slot) => {
										if (restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time) {
											return {
												d: weekdays[slot],
												start: restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time,
												end: restaurant?.active_menus.scheduled_delivery?.slots[slot].end_time,
											};
										}
									}),
								},
							],
						}),
					);
				});
			} else if (Basket.order_type == 'scheduled-collection') {
				const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				this.setState({ selectRestaurantsModalOpen: false }, () => {
					this.props.dispatch(
						getIkentooMenusForLocation(restaurant.business_location_id, {
							pickTime,
							json_time_selector: [
								{
									menuId: restaurant?.active_menus.scheduled_collection?.menu_id,
									availability: Object.keys(restaurant?.active_menus.scheduled_collection?.slots).map((slot) => {
										if (restaurant?.active_menus.scheduled_collection?.slots[slot].start_time) {
											return {
												d: weekdays[slot],
												start: restaurant?.active_menus.scheduled_collection?.slots[slot].start_time,
												end: restaurant?.active_menus.scheduled_collection?.slots[slot].end_time,
											};
										}
									}),
								},
							],
						}),
					);
				});
			}
		});
	};
	titleClickHandler = () => {
		this.setState({ selectRestaurantsModalOpen: !this.state.selectRestaurantsModalOpen });
	};
	formatDataForSelect = () => {
		let formatedStores = [];
		this.props.restaurants.forEach((store) => {
			const orderType = Basket.order_type;
			let currentDT = moment.unix(Basket.collection_time).tz(getConfig().timezone);
			if (orderType == 'table') {
				currentDT = moment().tz(getConfig().timezone);
			}
			let minDT = currentDT;

			const storeOpened = isStoreOpened(store);
			const snoozedTimes = checkSnoozedTimes(store, orderType);
			let slotsAvailable = [];
			store.isEnabled = storeOpened;
			if (orderType == 'collection') {
				let additionalSettings = store && store.additional_delivery_settings ? store.additional_delivery_settings : {};
				additionalSettings = additionalSettings[Basket.getDeliveryOption()?.id];
				if (additionalSettings && additionalSettings?.asap === false && additionalSettings?.timePicker === false) {
					slotsAvailable = isTimeAvaibleInMenu(store.json_time_selector, currentDT);
				} else {
					const timeData = formatDataForTime(store, minDT, store.id, false, false, snoozedTimes, this.props.scheduled);
					slotsAvailable =
						timeData.length === 1 && timeData[0].text.toLowerCase() === 'closed'
							? false
							: timeData[0].value.toLowerCase() == 'asap'
								? true
								: moment(moment(minDT).format('HH:mm'), 'HH:mm').isSameOrAfter(moment(timeData[0].value, 'HH:mm'));
				}
				store.opened = slotsAvailable;

				store.isEnabled = storeOpened && slotsAvailable;
				if (store.is_published && store.can_collection_order) {
					formatedStores.push(store);
				}
			} else if (orderType == 'table') {
				const slotsAvailable = isTimeAvaibleInMenu(store.table_json_time_selector, currentDT);
				store.isEnabled = storeOpened && slotsAvailable;
				store.opened = slotsAvailable;
				if (store.is_published && store.can_table_order && Basket.isRestaurantAllowed(store)) {
					formatedStores.push(store);
				}
			} else if (orderType == 'pick-up-at-counter') {
				if (store.is_published && store.can_pick_up_at_counter) {
					const slotsAvailable = isTimeAvaibleInMenu(store.pick_up_at_counter_json_time_selector, currentDT, moment().tz(getConfig().timezone));
					store.isEnabled = storeOpened && slotsAvailable;
					store.opened = slotsAvailable;

					formatedStores.push(store);
				}
			} else if (orderType == 'browse-menu') {
				if (store.is_published && store.can_browse_menu) {
					formatedStores.push(store);
					store.isEnabled = true;
				}
			} else if (orderType == 'charter-delivery') {
				if (store.is_published && store.can_charter_delivery_order) {
					const slotsAvailable = this.checkAvailableSlotsForToday(store);
					store.isEnabled = storeOpened && slotsAvailable;
					store.opened = slotsAvailable;
					formatedStores.push(store);
				}
			} else if (orderType == 'scheduled-collection') {
				if (store.is_published && store.can_scheduled_collection_order) {
					const collectionTime = currentDT.format('DD/MM/YYYY');
					const daysAhead = store?.active_menus?.scheduled_collection?.days_ahead + 1 || 8;
					const timezone = getConfig().timezone;
					const unavailableDates = store?.active_menus?.scheduled_collection?.unavailable_dates?.map((slot) => moment(slot, 'DD/MM/YYYY').format('DD/MM/YYYY')) ?? [];
					const futureDays = Array(daysAhead)
						.fill('')
						.map((day, i) => moment().tz(timezone).add(i, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('DD/MM/YYYY'))
						.filter((day) => !unavailableDates.includes(day));

					let slotsAvailable = true;
					if (!futureDays.includes(collectionTime)) {
						slotsAvailable = false;
					} else {
						const collectionDate = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('d');
						let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
						const dayName = days[collectionDate];
						const slots = store?.active_menus?.scheduled_collection?.slots?.[dayName] ?? false;
						const collectionHour = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
						if (!slots) {
							slotsAvailable = false;
						}
						slotsAvailable = isTimeInRange(collectionHour, slots?.start_time, slots?.end_time);
					}
					store.isEnabled = storeOpened && slotsAvailable;
					store.opened = slotsAvailable;
					formatedStores.push(store);
				}
			} else if (orderType == 'scheduled-delivery') {
				if (store.is_published && store.can_scheduled_delivery_order) {
					const collectionTime = currentDT.format('DD/MM/YYYY');
					const daysAhead = store?.active_menus?.scheduled_delivery?.days_ahead + 1 || 8;
					const timezone = getConfig().timezone;
					const unavailableDates = store?.active_menus?.scheduled_delivery?.unavailable_dates?.map((slot) => moment(slot, 'DD/MM/YYYY').format('DD/MM/YYYY')) ?? [];
					const futureDays = Array(daysAhead)
						.fill('')
						.map((day, i) => moment().tz(timezone).add(i, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('DD/MM/YYYY'))
						.filter((day) => !unavailableDates.includes(day));

					let slotsAvailable = true;
					if (!futureDays.includes(collectionTime)) {
						slotsAvailable = false;
					} else {
						const collectionDate = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('d');
						let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
						const dayName = days[collectionDate];
						const slots = store?.active_menus?.scheduled_delivery?.slots[dayName] ?? false;
						const collectionHour = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
						if (!slots) {
							slotsAvailable = false;
						}
						slotsAvailable = isTimeInRange(collectionHour, slots?.start_time, slots?.end_time);
					}
					store.isEnabled = storeOpened && slotsAvailable;
					store.opened = slotsAvailable;
					formatedStores.push(store);
				}
			}
		});
		return formatedStores;
	};
	generateTitle = (stores) => {
		return (<div className='multi-venue-restaurant-picker'>
			{stores.map((store, i) => (
				<div key={`store_${i}`} onClick={() => this.selectMultiVenueRestaurant(store)} className={`${store.name == Basket.getRestauranName() ? 'store-selected' : ''}`}>{store.name}</div>
			))}
		</div>)
	}
	onSearchInputHandler = (val) => {
		if (getConfig().flags.removeFiltersFromMenu) {
			this.filterMenuItems(val);
			return;
		}
		const active = val !== '' || this.state.selectedDietary.length > 0 || this.state.selectedAllergens.length > 0;
		this.setState({ searchOpened: active, ...(active ? {} : { selectedMenu: [] }) }, () => this.filterMenuItems(val));
	}
	checkAvailableSlotsForToday = (restaurant) => {
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let today = days[moment().format('d')];
		const day = {
			Monday: 'w1',
			Tuesday: 'w2',
			Wednesday: 'w3',
			Thursday: 'w4',
			Friday: 'w5',
			Saturday: 'w6',
			Sunday: 'w0',
		};
		let selectedRestaurant = restaurant
		let deliveryTimes = selectedRestaurant.charter_delivery_times_json;
		let flag = false;
		if (!isEmptyObject(deliveryTimes)) {
			for (let i = 0; i < deliveryTimes.length; i++) {
				deliveryTimes[i].availability.forEach((dt) => {
					if (dt.d === day[today] && dt?.active !== false) {
						let addedTime = null;
						addedTime = moment().add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
						if (addedTime.isBefore(moment(dt.end, 'hh:mm'))) {
							flag = true;
						}
					}
				});
			}
		}

		return flag;
	};
	render() {
		const { __, scrollTop, ikentooMenuError } = this.props;
		const { selectedCategory, ikentooMenu, selectedMenu } = this.state;
		if (ikentooMenu?.ikentooMenuId !== this.props.ikentooMenu?.ikentooMenuId && this.props.ikentooMenu.ikentooMenuId) {
			this.setState({ ikentooMenu: this.props.ikentooMenu, originalMenu: this.props.ikentooMenu }, () => {
				if (this.hasActiveMenuFilters()) {
					this.filterMenuItems(this.state.searchItemsValue);
				}
			})
		}
		let menuDisplayType = this.state.selectedMenuType;
		let categories = this.parseCategories({ selectedMenu, ikentooMenu, menuDisplayType });
		const menuItems = Basket.flattenMenuItems(this.state.originalMenu?.menuEntryGroups).filter((item) => ['menuItem', 'menuDeal'].includes(item['@type']));
		const menuDietary = [...new Set(menuItems.map((item) => item.itemRichData?.dietaryFlags || []).flat().map((flag) => flag.standard_name).filter(Boolean))];
		const menuAllerges = [...new Set(menuItems.map((item) => item.itemRichData?.allergenCodes || []).flat().filter(Boolean))];
		const draftMatchesCount = menuItems.filter((item) => this.matchesMenuFilters(item, this.state.draftDietary, this.state.draftAllergens)).length;
		const hasMenuFilterOptions = menuDietary.length > 0 || menuAllerges.length > 0;
		const showFiltersWithSearch = !getConfig().flags.removeFiltersFromMenu;

		let formatedStores = this.formatDataForSelect();
		if (Basket.has_multi_basket && getConfig().flags.geolocationDisabled) {
			const stores = deepCopy(formatedStores);
			let openedRestaurants = stores.filter((store) => store.opened);
			let closedRestaurants = stores.filter((store) => !store.opened);
			openedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			openedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			closedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			closedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			formatedStores = [...openedRestaurants];
		}
		return (
			<Loading>
				<Layout
					onSearchHandler={this.onSearchHandler}
					{...(showFiltersWithSearch
						? { filtersCount: this.state.selectedDietary.length + this.state.selectedAllergens.length, hasFilterIcon: hasMenuFilterOptions }
						: { onSearchInputHandler: this.onSearchInputHandler, searchActive: this.state.searchOpened })}
					hasSearchIcon
					headerWithTitle
					title={Basket.has_multi_basket && Basket.getRestaurant() ? this.generateTitle(formatedStores) : Basket.getDeliveryOption()?.label ?? __('Menu')}
					noPadding
					scrollY={false}
					backHandler={this.backHandler}
					showHamburger={this.state.hideCategoryBar ? false : (Basket.has_multi_basket ? false : selectedMenu ? selectedMenu.length === 0 : true)}
					color="transparent"
					{...(Basket.has_multi_basket ? { onTitleClickHandler: () => { } } : {})}

				>
					{showFiltersWithSearch && <Modal
						className="search-products-modal"
						isOpen={this.state.searchModalOpen}
						onDidDismiss={this.closeSearchModal}
					>
						<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
							<Title className='modal-title'>{__('Search products')}</Title>
							
							<IonItem lines="none" className="search-products-item">
								<IonIcon slot="start" icon={search} />
								<IonInput
									id="products_search"
									value={this.state.searchItemsValue}
									clearInput
									onIonInput={(e) => this.onSearchInputHandler(e.target.value)}
									placeholder={__('Search products')}
								/>
							</IonItem>
							<div className="search-filters-scroll">
								{menuDietary.length > 0 && (
									<>
										<Spacer size={5} />
										<StrongText className="search-filters-title text-to-update">{__('Dietary')}</StrongText>
										<div className="search-filters-pills">
											{menuDietary.map((flag) => (
												<IonButton
													key={flag}
													size="small"
													fill="clear"
													className={`search-filter-pill ${this.state.draftDietary.includes(flag) ? 'active' : ''}`}
													onClick={() => this.toggleMenuFilter('draftDietary', flag)}
												>
													<NormalText>{__(this.getDietaryLabel(flag))}</NormalText>
												</IonButton>
											))}
										</div>
									</>
								)}
								{menuAllerges.length > 0 && (
									<>
										<Spacer size={5} />
										<StrongText className="search-filters-title text-to-update">{__('Allergens to avoid')}</StrongText>
										<div className="search-filters-pills">
											{menuAllerges.map((code) => (
												<IonButton
													key={code}
													size="small"
													fill="clear"
													className={`search-filter-pill ${this.state.draftAllergens.includes(code) ? 'active' : ''}`}
													onClick={() => this.toggleMenuFilter('draftAllergens', code)}
												>
													<NormalText>{__(this.getAllergenLabel(code))}</NormalText>
												</IonButton>
											))}
										</div>
									</>
								)}
							</div>
							<Spacer size={1} />
							{hasMenuFilterOptions ?
								<div className="search-filters-actions">
									<IonButton className="button-uppercase" expand="block" fill="outline" color="primary" onClick={this.clearMenuFilters}>
										{__('Clear all')}
									</IonButton>
									<IonButton className="button-uppercase" expand="block" color="primary" onClick={this.applyMenuFilters}>
										{draftMatchesCount === 1 ? __('Show {count} result', { count: draftMatchesCount }) : __('Show {count} results', { count: draftMatchesCount })}
									</IonButton>
								</div>
								:
								<IonButton className="button-uppercase" expand="block" color="primary" onClick={() => this.setState({ searchModalOpen: false })}>
										{draftMatchesCount === 1 ? __('Show {count} result', { count: draftMatchesCount }) : __('Show {count} results', { count: draftMatchesCount })}
								</IonButton>

							}

						</div>
					</Modal>}

					<IonActionSheet
						isOpen={this.state.selectRestaurantsModalOpen}
						onDidDismiss={() => this.setState({ selectRestaurantsModalOpen: false })}
						header={__('Select restaurant')}
						buttons={[
							...formatedStores.map((store) => {
								if (store.name == Basket.getRestauranName()) {
									return {
										cssClass: 'action-sheet-active',
										text: store.name,
										handler: () => this.setState({ selectRestaurantsModalOpen: false }),
									};
								} else {
									return {
										text: store.name,
										cssClass: !store.isEnabled ? 'disabled-element disabled-opacity' : '',
										handler: () => this.selectMultiVenueRestaurant(store),
									};
								}
							}),

							{
								text: __('Cancel'),
								role: 'cancel',
								data: {
									action: 'cancel',
								},
							},
						]}
					></IonActionSheet>

					{ikentooMenuError ?
						<>
							<div className="order-content ">
								<NormalText className="no-items-message">{__('Oops, there was a problem with the menu. Please, try again.')}</NormalText>
							</div>
						</>
						: <>
							{!isDefined(ikentooMenu) ? null : menuDisplayType === 1 ? (
								<div className="segment-holder">
									{getConfig().frenchDisclaimer?.disclaimerImage && (
										<>
											<div className="order-disclaimer-wrapper">
												<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
											</div>
										</>
									)}
									{<div className="order-categories">
										{(categories || []).length > 0 ? (
											<div className="order-categories-inner">
												<>
													{(showFiltersWithSearch || !this.state.searchOpened) && <>
														{categories?.map((category, index) => {
															return (
																<IonButton
																	key={index}
																	size="small"
																	fill='clear'
																	className={selectedCategory === index ? 'category-button active' : 'category-button'}
																	onClick={() => this.scrollTo(`${category.name}_${index}`, index)}
																>
																	<StrongText className='primary-color'>{Basket.getCategoryName(category, this.props.profile)}</StrongText>
																</IonButton>
															);
														})}</>}
												</>

											</div>
										) : (
											<>
												<Spacer />
												{this.hasActiveMenuFilters() ?
													showFiltersWithSearch ? <NoFilterResults openFilters={this.onSearchHandler} /> : <NormalText className="no-items-message">{__('No items found')}</NormalText>
													:
													<NormalText className="no-items-message">{__('Oops, there was a problem with the menu. Please, try again.')}</NormalText>
												}
											</>
										)}
									</div>}
									<div className={`order-content `} style={this.state.scrollToCategoryKey ? { visibility: 'hidden' } : {}}>

										<OrderList
											scrollTopPosition={scrollTop}
											selectCategoryOnScroll={this.selectCategoryOnScroll}
											category={!isEmptyObject(ikentooMenu) ? ikentooMenu : null}
											menuRefs={this.state.menuRefs ? this.state.menuRefs : []}
											menuFilters={this.getMenuFilters()}
										><div className="order-header-content-wrapper ">
												{(ikentooMenu?.menuName?.indexOf('Default') === -1 && !isEmptyObject(Basket?.getRestaurant())) && (
													<>
														{!Basket.has_multi_basket && !this.state.searchOpened &&
															<div >{this.drawContentHeader(__, Basket.getDeliveryOption(), Basket.getOrderType(), Basket.getDeliveryAddress())}</div>

														}
													</>
												)}
											</div></OrderList>
										{Basket.itemsCount() > 0 ? (
											<div className="view-order-button">
												<IonButton
													{...(getConfig()?.customButtons?.viewOrder && { style: { '--ion-color-primary': getConfig()?.customButtons?.viewOrder } })}
													color='primary'
													className='button-uppercase'
													onClick={() => forwardTo('/order-summary')}
													expand="block">
													<IonGrid>
														<IonRow>
															<IonCol>
																{Basket.itemsCountAll()}&nbsp;
																{Basket.itemsCountAll() === 1 ? __('Item') : __('Items')}
															</IonCol>
															<IonCol>{__('View basket')}</IonCol>

															<IonCol>{Basket.calculateItemsTotal()}</IonCol>
														</IonRow>
													</IonGrid>
												</IonButton>
											</div>
										) : null}
									</div>
								</div>
							) : (
								<>
									<div className={`segment-holder grid-menus ${Basket.itemsCount() > 0 ? 'have-items-in-basket' : ''}`}>
										<div className="order-header-content-wrapper ">
											{ikentooMenu?.menuName?.indexOf('Default') === -1 && (
												<>
													{!Basket.has_multi_basket && !this.state.searchOpened &&
														<>
															<div className="default-padding">{this.drawContentHeader(__, Basket.getDeliveryOption(), Basket.getOrderType(), Basket.getDeliveryAddress())}</div>
															<Spacer size={2} />
														</>
													}

												</>
											)}
										</div>
										{getConfig().frenchDisclaimer?.disclaimerImage && (
											<>
												<div className="order-disclaimer-wrapper">
													<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
												</div>
											</>
										)}

										<div className="order-categories">
											<TileOrderList
												selectMenu={(index) => {
													this.selectMenu(index);
												}}
												onScrollToCategory={this.handleScrollToCategory}
												category={categories}
												selectedMenu={this.state.selectedMenu}
												menuFilters={this.getMenuFilters()}
											></TileOrderList>
										</div>
										<div className="view-order-button">
											{Basket.itemsCount() > 0 ? (
												<div className="">
													<IonButton
														{...(getConfig()?.customButtons?.viewOrder && { style: { '--ion-color-primary': getConfig()?.customButtons?.viewOrder } })}
														onClick={() => forwardTo('/order-summary')}
														className='button-uppercase'
														expand="block"
														color="primary">
														<IonGrid>
															<IonRow>
																<IonCol>
																	{Basket.itemsCountAll()}&nbsp;
																	{Basket.itemsCountAll() === 1 ? __('Item') : __('Items')}
																</IonCol>
																<IonCol>{__('View basket')}</IonCol>

																<IonCol>{Basket.calculateItemsTotal()}</IonCol>
															</IonRow>
														</IonGrid>
													</IonButton>
												</div>
											) : null}
										</div>
									</div>
								</>
							)}
						</>}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { auth, clientProfile, navConfig, driverBookingPending, driverBookingMessage } = state.common;
	const { restaurants, ikentooMenu, defaultMenu, restaurantsUpdated, ikentooMenuError, allergens } = state.restaurants;
	const { scrollTop } = state.orders;
	const { profile } = state.profile
	return {
		auth,
		restaurants: restaurants || [],
		ikentooMenu: ikentooMenu || {},
		defaultMenu: defaultMenu || {},
		basketUpdated: state.orders.basketUpdated,
		restaurantsUpdated,
		scrollTop,
		clientProfile,
		navConfig,
		driverBookingPending,
		driverBookingMessage,
		profile,
		ikentooMenuError,
		allergens
	};
};

export default connect(stateToProps)(withTranslation(OrderPage));
